// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vd__3CoHz","formFooter":"vd__1h0n_","link":"vd__3UPNz"};